module.exports = "/images/vendor/flag-icon-css/flags/4x3/er.svg?e5e5e397d9e7e40f3b3078e291e3b396";